theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };
  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };
  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  var libraries = {
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'plyr/v2.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };
  function load(libraryName, callback) {
    var library = libraries[libraryName];
    if (!library) return;
    if (library.status === status.requested) return;
    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }
    library.status = status.requested;
    var tag;
    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }
    tag.id = library.tagId;
    library.element = tag;
    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }
  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }
  return {
    load: load
  };
})();

function ProductOptions_toConsumableArray(arr) { return ProductOptions_arrayWithoutHoles(arr) || ProductOptions_iterableToArray(arr) || ProductOptions_unsupportedIterableToArray(arr) || ProductOptions_nonIterableSpread(); }
function ProductOptions_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function ProductOptions_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ProductOptions_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductOptions_arrayLikeToArray(o, minLen); }
function ProductOptions_iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
function ProductOptions_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return ProductOptions_arrayLikeToArray(arr); }
function ProductOptions_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ProductOptions_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductOptions_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductOptions_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductOptions_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductOptions_defineProperties(Constructor, staticProps); return Constructor; }
var ProductOptions = function () {
  function ProductOptions(product) {
    ProductOptions_classCallCheck(this, ProductOptions);
    this.productHandle = product.handle;
    this.optionsCount = product.options.length;
    this.variants = product.variants;
  }
  ProductOptions_createClass(ProductOptions, [{
    key: "getVariantFromOptions",
    value: function getVariantFromOptions(options) {
      var variant = null;
      this.variants.forEach(function (potentialVariant) {
        var found = true;
        for (var i = 0; i < potentialVariant.options.length; i++) {
          if (options[i] !== potentialVariant.options[i]) {
            found = false;
          }
        }
        if (found) {
          variant = potentialVariant;
        }
      });
      return variant || false;
    }
  }, {
    key: "getClosestVariantFromOptions",
    value: function getClosestVariantFromOptions(options) {
      var closestVariant = null,
          matchingValues = 0;
      this.variants.forEach(function (variant) {
        var tempMatchingValues = 0;
        for (var i = 0; i < variant.options.length; i++) {
          if (options[i] === variant.options[i]) {            
            tempMatchingValues++;
          } else {
            break;
          }
        }
        if (tempMatchingValues >= matchingValues) {
          closestVariant = variant;
          matchingValues = tempMatchingValues;
        }
      });    
      return closestVariant ? closestVariant : false;
    }
  }, {
    key: "getVariantOrClosestFromOptions",
    value: function getVariantOrClosestFromOptions(options) {
      return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
    }
  }]);
  return ProductOptions;
}();

function VariantHelper_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function VariantHelper_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function VariantHelper_createClass(Constructor, protoProps, staticProps) { if (protoProps) VariantHelper_defineProperties(Constructor.prototype, protoProps); if (staticProps) VariantHelper_defineProperties(Constructor, staticProps); return Constructor; }
var VariantHelper = function () {
  function VariantHelper(product, $variants, $options, $form) {
    VariantHelper_classCallCheck(this, VariantHelper);
    var _this = this;
    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.$form = $form;
    this.productOptions = new ProductOptions(this.product);
    this.optionsTypes = {
      select: 'select-one',
      radio: 'radio'
    };
    this._bindEvents();
    if (this.$options.length) {
      if (this.$options[0].type === this.optionsTypes.select) {
        this.optionsType = this.optionsTypes.select;
      } else if (this.$options[0].type === this.optionsTypes.radio) {
        this.optionsType = this.optionsTypes.radio;
      } else {
        this._unbindEvents();
      }
    } else {
      this.optionsType = null;
    }
    this._switchVariant(true);
    if (this.optionsType === this.optionsTypes.radio) {
      Swatches(this.$form);      
    };
  }
  VariantHelper_createClass(VariantHelper, [{
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this = this;
      this.$options.forEach(function (o) {
        o.onchange = function(){
          var f = o;
          return _this._switchVariant(f);
        };
      });
    }
  }, {
    key: "_switchVariant",
    value: function _switchVariant(f, force) {
      var _this = this,
          firstLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false,
          options = [],
          product = this.product,
          variant = null;    
      if (this.optionsType === this.optionsTypes.select) {
        if (f != true) {
          var pU = f.options[f.selectedIndex];
        }
        this.$options.forEach(function (i, option) {
          options.push(i.value);
        });
      } else if (this.optionsType === this.optionsTypes.radio) {
        var pU = f;
        this.$options.forEach(function (option) {
          if (option.checked) {
            options.push(option.value);
          }
        });
      } else {
        return;
      }
      if (f == true) {
        variant = this.productOptions.getVariantOrClosestFromOptions(options);
      } else {
        if (!pU.hasAttribute('data-product-url')) {
          variant = this.productOptions.getVariantOrClosestFromOptions(options);
        } else {
          const productElement = this.$form.closest('.product-container'),
                sectionId = productElement.dataset.sectionId,
                oldProductUrl = productElement.dataset.productUrl,
                optionValueElement = pU,
                newProductUrl = pU.getAttribute('data-product-url'),
                newVariantId = pU.getAttribute('data-variant-id'); 
          let params = 'section_id=' + sectionId + '&';
          if (newVariantId) {
            params += 'variant=' + newVariantId;
          } else {
            const selectedOptionValues = Array.from(this.$el.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
            params += 'option_values=' + selectedOptionValues;
          }
          fetch(newProductUrl + '?' + params)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html'),
                  sectionNew = html.querySelector('.product-container'),
                  sectionIdNew = sectionNew.dataset.sectionId,
                  productTypeNew = sectionNew.dataset.productType,
                  optionValueElementNew = html.querySelector('.product-container [data-product-url="' + newProductUrl + '"]');
              productElement.innerHTML = sectionNew.innerHTML;
              const s = {
                el: document.getElementById('product-id-'+ sectionIdNew), 
                id: sectionIdNew, 
                type: productTypeNew
              };
              Product(s);
              optionValueElementNew.focus();
          });
          return;
        }
      }      
      if (this.optionsType === this.optionsTypes.select) {
        this._switchVariantSelect(variant);
      } else if (this.optionsType === this.optionsTypes.radio) {
        this._switchVariantRadio(variant,f);
      } else {
        return;
      }      
      this.$variants.value = variant.id;
      var isProduct = function isProduct(compareProduct) {
        return compareProduct === product;
      };
      let event = new CustomEvent('product-variant-switch', {
        detail: {
          product: product,
          variant: variant,
          firstLoad: firstLoad,
          isProduct: isProduct
        }
      });
      window.dispatchEvent(event);
    }
  }, {
    key: "_switchVariantSelect",
    value: function _switchVariantSelect(variant) {
      var _this2 = this;
      let availableOptions = this.productOptions.variants;
      var $optionEls = this.$form.querySelectorAll('[data-product-options] .single-option-selector option');
      $optionEls.forEach(function (o) {
        if (o.hasAttribute('data-product-url')) {       
          o.disabled = false;
          o.classList.remove('disabled');   
        } else {       
          o.disabled = true;
          o.classList.add('disabled');   
        }
      });
      for (var i = 0; i < this.product.options.length; i++) {
        for (const v of _this2.product.options[i].values) {
          let s = _this2.$form.querySelector('.single-option-selector-' + [i] + ' option[value="' + v.replace(/["\\]/g, '\\$&') + '"]'),
              label = _this2.$form.querySelector('.selectors[data-option-index="' + [i] + '"] label span');
          if (label) {
            label.textContent = variant.options[i];
          };
          if (v === variant.options[i]) {
            s.disabled = false;
            s.classList.remove('disabled');            
            s.selected = true;
          }
          for (const o of availableOptions) {
            if (o.options[0] == v) {
              s.disabled = false;
              if (o.available) {
                s.classList.remove('disabled');
              };
            }
            if (o.options[1] && v === variant.options[0] && v === o.options[0]) {
              let sO = _this2.$form.querySelector('.single-option-selector-1 option[value="' + o.options[1].replace(/["\\]/g, '\\$&') + '"]');
              sO.disabled = false;
              if (o.available) {
                sO.classList.remove('disabled');
              };
            }
            if (o.options[2] && variant.options[0] === o.options[0] && v === variant.options[1] && v === o.options[1]) {
              let sO = _this2.$form.querySelector('.single-option-selector-2 option[value="' + o.options[2].replace(/["\\]/g, '\\$&') + '"]');
              sO.disabled = false;
              if (o.available) {
                sO.classList.remove('disabled');
              };
            }            
          }
        }
      }
    }
  }, {
    key: "_switchVariantRadio",
    value: function _switchVariantRadio(variant,f) {
      var _this3 = this;
      let availableOptions = this.productOptions.variants;
      this.$options.forEach(function (o) {
        if (o.hasAttribute('data-product-url')) {
          o.parentNode.classList.remove('hidden', 'soldout'); 
        } else {
          o.parentNode.classList.add('hidden', 'soldout'); 
        }
      });
      for (var i = 0; i < this.product.options.length; i++) {
        for (const v of _this3.product.options[i].values) {
          let s = _this3.$form.querySelector('[data-option-index="' + [i] + '"] input[value="' + v.replace(/["\\]/g, '\\$&') + '"]'),
              legend = _this3.$form.querySelector('.selectors[data-option-index="' + [i] + '"] legend span');
          if (legend) {
            legend.textContent = variant.options[i];
          };
          s.parentNode.classList.remove('active', 'var_ignore');
          if (v === variant.options[i]) {
            s.checked = true;
            s.parentNode.classList.add('active');
          }          
          for (const o of availableOptions) {
            if (o.options[0] == v) {
              s.parentNode.classList.remove('hidden');
              if (o.available) {
                s.parentNode.classList.remove('soldout');
              }
            }
            if (o.options[1] && v === variant.options[0] && v === o.options[0]) {
              let sO = _this3.$form.querySelector('[data-option-index="1"] input[value="' + o.options[1].replace(/["\\]/g, '\\$&') + '"]');
              sO.parentNode.classList.remove('hidden');
              if (o.available) {
                sO.parentNode.classList.remove('soldout');
              }
            }
            if (o.options[2] && variant.options[0] === o.options[0] && v === variant.options[1] && v === o.options[1]) {              
              let sO = _this3.$form.querySelector('[data-option-index="2"] input[value="' + o.options[2].replace(/["\\]/g, '\\$&') + '"]');
              sO.parentNode.classList.remove('hidden');
              if (o.available) {
                sO.parentNode.classList.remove('soldout');
              }
            }
          }
        }
      }      
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
        return true;
      }
      return false;
    }
  }, {
    key: "getSelectedVariant",
    value: function getSelectedVariant() {
      if (this.isDefault()) {
        return this.product.variants[0];
      }
      var options = [];
      if (this.optionsType === this.optionsTypes.select) {
        this.$options.forEach(function (i, option) {
          options.push(i.value);          
        });
      } else if (this.optionsType === this.optionsTypes.radio) {
        this.$options.forEach(function (option) {
          if (option.checked) {
            options.push(option.value);
          }
        });
      } else {
        return null;
      }
      return this.productOptions.getVariantFromOptions(options);        
    }
  }]);
  return VariantHelper;
}();

function ProductForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductForm_defineProperties(Constructor, staticProps); return Constructor; }
var ProductForm = function () {
  function ProductForm(el) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    ProductForm_classCallCheck(this, ProductForm);
    this.$el = options.container || el;
    this.$form = options.form || el;
    this.options = options;
    this.product = options.product;
    this.product.options = options.productVariants;
    this.postMessage = this.options.postMessage;
    this.isThemeEditor = Shopify && Shopify.designMode;
    this.useHistory = options.useHistory && !this.isThemeEditor && window.history && history.replaceState;
    this.events = [];
    Cart(options.productEl);
    this.events.push(
      window.addEventListener('product-variant-switch', function(event, data) {
        var data = event.detail;
        _this._changeVariant(data);
      })
    )
    this.$options = this.$el.querySelectorAll('[data-option]');
    this.$variants = this.$el.querySelector('[data-variants]');
    this.variantHelper = new VariantHelper(this.options.product, this.$variants, this.$options, this.$form);
  }
  ProductForm_createClass(ProductForm, [{
    key: "unload",
    value: function unload() {      
    }
  }, {
    key: "_changeVariant",
    value: function _changeVariant(data) {
      document.dispatchEvent(new CustomEvent('_changeVariant', {
        bubbles: true
      }));    
      var variant = data.variant;
      this._changeUrl(variant);
      if (this.options.onVariantChange) {
        this.options.onVariantChange(variant);
      }
    }
  }, {
    key: "_changeUrl",
    value: function _changeUrl(variant) {
      if (!this.useHistory) {
        return;
      }
      p = {
        variant: variant.id
      }
      params = Object.keys(p).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(p[k])
      }).join('&');
      var url = "".concat(this.options.product.handle, "?").concat(params);
      history.replaceState({}, 'variant', url);
    }
  }]);
  return ProductForm;
}();

function ProductZoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductZoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductZoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductZoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductZoom_defineProperties(Constructor, staticProps); return Constructor; }
var ProductZoom = function () {
  function ProductZoom(el) {
    var _this = this;
    ProductZoom_classCallCheck(this, ProductZoom);
    this.el = el;
    this.$el = el;
    this.$img = this.$el.querySelector('img');
    this.scale = this.$img.getAttribute('width') / this.$el.getBoundingClientRect().width;
    this.zoomable = this.scale >= 1.25;
    this.framerate = 60;
    this.zoomed = false;
    this.resetZoom = this._resetZoom.bind(this);
    this._init();
    this.$img.addEventListener('img:load', _this._init());
  }
  ProductZoom_createClass(ProductZoom, [{
    key: "_init",
    value: function _init() {
      this.disableZoom();
      if (this.zoomable) {
        this.enableZoom();        
      }
    }
  }, {
    key: "enableZoom",
    value: function enableZoom() {
      this.$el.classList.add('product-image-zoomable');
      this._bindEvents();
    }
  }, {
    key: "disableZoom",
    value: function disableZoom() {
      this.$el.classList.remove('product-image-zoomable');
      this._resetZoom();
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;
      this.$el.onclick = function(event){
        _this2._toggleZoom(event.clientX, event.clientY);
      };
      window.onresize = function(event){
        this.resetZoom
      };
    }
  }, {
    key: "_toggleZoom",
    value: function _toggleZoom(clientX, clientY) {
      var _this3 = this;
      if (!theme.mobile && theme.dragging) return;      
      if (!this.zoomed) {
        this.$img.srcset = this.$img.getAttribute('data-zoom');        
        if (theme.detectmob) {
          this.$el.ontouchcancel = function(){
            _this3._resetZoom();
            return
          };
          document.body.classList.add('zoom-enabled');
          if (this.$el.closest('.glider')) {
            this.$el.closest('.glider').classList.add('no-drag');
          };
          this.$el.ontouchmove = theme.Helpers.debounce(function (event) {
            var touch = event.touches[0];
            _this3._positionZoom(touch.clientX, touch.clientY);
          }, 100 / this.framerate, true, true);
        } else {
          this.$el.onmouseout = function(){
            _this3._resetZoom();
            return
          };
          this.$el.onmousemove = theme.Helpers.debounce(function (event) {
            _this3._positionZoom(event.clientX, event.clientY);
          }, 100 / this.framerate, true, true);        
        }          
        this.$el.classList.add('product-image-zoomed');          
        this.$img.style.transform = 'scale(' + this.scale + ')';
        this._positionZoom(clientX, clientY);
        this.zoomed = true;
      } else {
        this._resetZoom();
      }
    }
  }, {
    key: "_resetZoom",
    value: function _resetZoom() {
      this.$el.ontouchend = null;
      this.$el.ontouchmove = null;
      this.$el.onmousemove = null;
      this.$el.onmouseout = null;
      if (theme.detectmob) {
        document.body.classList.remove('zoom-enabled');
        if (this.$el.closest('.glider')) {
          this.$el.closest('.glider').classList.remove('no-drag');
        };
      }
      this.$el.classList.remove('product-image-zoomed');
      this.$img.style.removeProperty('transform');
      this.zoomed = false;
    }
  }, {
    key: "_positionZoom",
    value: function _positionZoom(clientX, clientY) {
      if (!this.zoomed) {
        return;
      }
      var figRect = this.$el.getBoundingClientRect(),
          imgRect = this.$img.getBoundingClientRect(),
          figHalfWidth = figRect.width / 2,
          figHalfHeight = figRect.height / 2,
          centerX = figRect.left + figHalfWidth,
          centerY = figRect.top + figHalfHeight,
          widthDiff = imgRect.width / 2 - figHalfWidth,
          heightDiff = imgRect.height / 2 - figHalfHeight,
          translateX = (centerX - clientX) / figHalfWidth * widthDiff / this.scale,
          translateY = (centerY - clientY) / figHalfHeight * heightDiff / this.scale;
      this.$img.style.transform = "scale(" .concat(this.scale, ") translate(").concat(translateX, "px, ").concat(translateY, "px)");
    }
  }]);
  return ProductZoom;
}();

function ProductGallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductGallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductGallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGallery_defineProperties(Constructor, staticProps); return Constructor; }
var ProductGallery = function () {
  function ProductGallery(el) {      
    var _this = this,settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    ProductGallery_classCallCheck(this, ProductGallery);
    this.el = el;      
    this.settings = settings;
    var sectionId = this.settings.section.id;
    this.viewport = this.el.querySelector('#main-product-image-' + sectionId);  
    this.featured = this.el.querySelector('#featured-' + sectionId);
    this.navigation = this.el.querySelector('#thumbnails-' + sectionId);
    this.thumbnails = this.el.querySelectorAll('.thumbnails-' + sectionId + ' .button');
    this.figures = this.viewport.querySelectorAll('figure');
    this.selected = {
      figure: this.viewport.querySelector('figure.visible'),
      thumbnail: null
    };
    this.media = {
      images: [],
      models: [],
      videos: []
    };
    var variantImages = {},
        thumbnails,
        variant,
        variantImage,
        opt_key,
        opt_val,
        loop_index,
        vars = settings.section.data.product_info.variants,
        opts = settings.section.data.product_info.options,
        options = settings.section.el.querySelectorAll('[data-option]'),
        optionsTypes = {
          select: 'select',
          radio: 'radio'
        };    
    function vChange(image) {
      opts.forEach(function(o,i) {
        loop_index = 'option-' + i;
        if (variantImages[image][loop_index] !== null) {
          var index = i;          
          if (settings.section.data.option_type === optionsTypes.select) {
            var sos = document.querySelector('[name="' + settings.section.id + '-' + settings.section.data.product_info.id + '-option' + index + '"]');
            sos.value = variantImages[image][loop_index];
            sos.dispatchEvent(new Event('change'));
          } else {
            options.forEach(function (o) {
              if (o.value == variantImages[image][loop_index]) {
                o.checked = true;
                o.dispatchEvent(new Event('change'));
              }
              return
            });
          }          
        }
      });
    }
    if (this.featured) {
      this.slideshow = true;
      this.slideshow_section = false;      
      var FCarousel = document.getElementById('featured-'+ sectionId);      
      if (FCarousel) {
        this.active = this.featured.querySelector('.active .media-container');
        this.fthumbnails = this.viewport.querySelectorAll('.thumbs');
        this.imageHeight(this.active);
          var mSI = FCarousel.querySelector('.active').getAttribute('data-product-gallery-figure'),
              next = document.getElementById('glider-featured-button-next-thumbs-' + sectionId),
              prev = document.getElementById('glider-featured-button-prev-thumbs-' + sectionId),
              glider = new Glider(FCarousel, {
                arrows: {
                  prev: prev,
                  next: next
                },
                draggable: true,
                rewind: true,
                scrollLock: true,
                skipTrack: true,
                slidesToShow: 1,
                slidesToScroll: 1
              });
          if (glider) {
          FCarousel.querySelector('.glider-track.slideshow').classList.add('loaded');
          Glider(this.featured).scrollItem(parseInt(mSI));
          FCarousel.addEventListener('glider-slide-visible', function(ev) {
            if (theme.busy) {
              _this.fthumbnails.forEach(function (t) {
                t.disabled = true;
              });
              return;
            } else {
              setTimeout(function() {
                theme.busy = false;
                _this.fthumbnails.forEach(function (t) {
                  t.disabled = false;
                });
              }, 350);
            }
            theme.busy = true;            
            if (theme.thumb) {
              theme.thumb = false;
              return;
            }            
            var featured = FCarousel.querySelector('.active img[src]');
            if (featured) {
              var image = featured.getAttribute('src').split('?')[0].replace(/(_1x)/,'');
                if (typeof variantImages[image] !== 'undefined') {
                  vChange(image);
                } else {
                _this._selectMediaByIndex(FCarousel.querySelector('.active').getAttribute('data-product-gallery-figure'));
              };
            } else {
              _this._selectMediaByIndex(FCarousel.querySelector('.active').getAttribute('data-product-gallery-figure'));              
            };            
          });
        }
      };
      var resizeTimer;
      window.addEventListener('resize', function(b) {
        if (cW == window.innerWidth) {
          return;
        }
        cW = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          _this.imageHeight(_this.active);
        }, 250);
      });
    }    
    if (this.navigation) {
      this.selected.thumbnail = this.navigation.querySelector('[data-product-gallery-selected="true"]');
      this.slideshow = true;
      this.slideshow_section = false;
      var TCarousel = document.getElementById('thumbnails-'+ sectionId);  
      if (TCarousel) {
        var next = document.getElementById('glider-button-next-thumbs-' + sectionId),
            prev = document.getElementById('glider-button-prev-thumbs-' + sectionId),
            glider = new Glider(TCarousel, {
              arrows: {
                prev: prev,
                next: next
              },
              draggable: true,
              dragVelocity:2.5,
              resizeLock: false,
              skipTrack: true, 
              slidesToShow: 4,
              slidesToScroll: 4
            });
        if (glider) {
          TCarousel.classList.add('loaded');
        }
      };
    }    
    vars.forEach(function(v) {
      variant = v;
      if ( typeof variant.featured_image !== 'undefined' && variant.featured_image !== null ) {
        variantImage =  variant.featured_image.src.split('?')[0].replace(/http(s)?:/,'');
        variantImages[variantImage] = variantImages[variantImage] || {};
        var opts = v.options
        opts.forEach(function(o,i) {
          opt_key = 'option-'+i;
          opt_val = o;
          if (typeof variantImages[variantImage][opt_key] === 'undefined') {
            variantImages[variantImage][opt_key] = opt_val;
          }
          else {
            var oldValue = variantImages[variantImage][opt_key];
            if ( oldValue !== null && oldValue !== opt_val )  {
              variantImages[variantImage][opt_key] = null;
            }
          }
        });
      }
    });
    this.thumbnails.forEach(function (thumbnail) {
      var _this2 = this;
      thumbnail.onclick = function(e){
        theme.thumb = true;
        var thumb = this.querySelector('img[src]'),
            image = thumb.getAttribute('src').split('?')[0].replace(/(_1x)/,'');
        if (typeof variantImages[image] !== 'undefined') {
          vChange(image);
        } else {
          _this._selectMediaByIndex(this.getAttribute('data-product-gallery-thumbnail'));          
        }
      }
    });
    var features = [];
    if (this.settings.zoom_enable && this.selected.figure.dataset.mediaType === 'image') {
      this._initZoom(this.selected.figure);
    }
    if (this.el.querySelector('[data-media-type="model"]')) {
      this.viewport.onclick = function(e){
        if ('shopifyXr' in e.target.dataset) {
          _this._onViewInYourSpaceClick(e.target);
        }
      };
      features.push({
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this._onModelLibraryLoad.bind(this)
      });
      features.push({
        name: 'shopify-xr',
        version: '1.0'
      });      
    }
    if (this.el.querySelector('[data-media-type="video"]')) {
      Promise.all([new Promise(function (resolve) {
        if (!document.querySelector('#plyr-stylesheet')) {
          var link = document.createElement('link');
          link.setAttribute('id', 'plyr-stylesheet');
          link.setAttribute('rel', 'stylesheet');
          link.setAttribute('href', 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');
          link.onload = resolve;
          document.body.appendChild(link);
        } else {
          resolve();
        }
      }), new Promise(function (resolve) {
        features.push({
          name: 'video-ui',
          version: '1.0',
          onLoad: resolve
        });
      })]).then(this._onVideoLibraryLoad.bind(this));
    }
    if (features.length) {
      Shopify.loadFeatures(features);
    }
  }
  ProductGallery_createClass(ProductGallery, [{
    key: "imageHeight",
    value: function imageHeight(a) {
      var newHeight = a.offsetHeight;
      this.featured.querySelector('.glider-track').style.height = newHeight + 'px';      
    }
  }, {
    key: "selectMediaByVariant",
    value: function selectMediaByVariant(variant) {
      if (variant.featured_media) {
        var figure = this.viewport.querySelector("[data-media=\"".concat(variant.featured_media.id, "\"]"));
      } else {
        var figure = this.viewport.querySelector("[data-product-gallery-figure='0']");
      }
      if (!figure) return;
      this._selectMediaByIndex(figure.dataset.productGalleryFigure);          
    }
  }, {
    key: "pauseVideos",
    value: function pauseVideos() {
      this.el.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      this.el.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      var excludeVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.media.videos.forEach(function (v) {
        if (v !== excludeVideo) {
          v.figure.querySelector('.plyr').tabIndex = -1;
          v.pause();
        }
      });
    }
  }, {
    key: "pauseModels",
    value: function pauseModels() {
      var excludeModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.media.models.forEach(function (m) {
        if (m !== excludeModel && m.ui.interacting) {
          m.ui.pause();
        }
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      this.events.unregisterAll();
      this.media.videos.forEach(function (v) {
        return v.unload();
      });
      this.media.images.forEach(function (i) {
        return i.unload();
      });
    }
  }, {
    key: "_onModelLibraryLoad",
    value: function _onModelLibraryLoad() {
      var _this2 = this,
          controls = ['zoom-in', 'zoom-out'];      
      theme.LibraryLoader.load('modelViewerUiStyles');
      if (document.fullscreenEnabled) controls.push('fullscreen');
      this.viewport.querySelectorAll('[data-media-type="model"]').forEach(function (modelFigure) {
        var modelEl = modelFigure.querySelector('model-viewer');
        _this2.media.models.push({
          ui: new Shopify.ModelViewerUI(modelEl, {
            controls: controls
          }),
          el: modelEl,
          figure: modelFigure
        });
        modelEl.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
          _this2.viewport.querySelector('.glider').classList.add('no-drag');
          theme.model = true;
        }.bind(this));
        modelEl.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
          _this2.viewport.querySelector('.glider').classList.remove('no-drag');
          theme.model = false;
        }.bind(this));
      });
    }
  }, {
    key: "_onViewInYourSpaceClick",
    value: function _onViewInYourSpaceClick(target) {
      if (target.dataset.shopifyModel3dId === this.selected.figure.dataset.media) return;
      var figure = this.viewport.querySelector("[data-media=\"".concat(target.dataset.shopifyModel3dId, "\"]"));
      this._selectMediaByEl(figure);
    }
  }, {
    key: "_selectMediaByEl",
    value: function _selectMediaByEl(el) {
      this._selectMediaByIndex(parseInt(el.dataset.productGalleryFigure, 10));
    }
  }, {
    key: "_onVideoLibraryLoad",
    value: function _onVideoLibraryLoad() {      
      var _this3 = this,
          videoFigures = this.viewport.querySelectorAll('[data-media-type="video"]'),
          _loop = function _loop(i) {
        var videoFigure = videoFigures[i],
            videoEl = videoFigure.querySelector('video'),
            player = new Shopify.Plyr(videoEl, {
          loop: {
            active: _this3.settings.loop_enable
          }
        });
        var video = {
          figure: videoFigure,
          el: videoEl,
          player: player,
          restart: function restart() {
            player.restart();
            player.play();
          },
          pause: function pause() {
            return player.pause();
          },
          play: function play() {
            return player.play();
          },
          unload: function unload() {
            return player.destroy();
          }
        };
        videoFigure.play = function(e){
          return _this3.pauseVideos(video);
        }        
        _this3.media.videos.push(video);
      };
      for (var i = 0; i < videoFigures.length; i++) {
        _loop(i);
      }
      videoFigures.forEach(function(v) {
        v.querySelector('.plyr').tabIndex = -1;
      });
    }
  }, {
    key: "_onVideoSelect",
    value: function _onVideoSelect(video) {
      video.figure.querySelector('.plyr').tabIndex = 0;
      if (!theme.detectmob) {
        video.play();
      }
    }
  }, {
    key: "_onMediaSelect",
    value: function _onMediaSelect(index) {
      var _this8 = this,
          focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false,
          figure = this.figures[index];
      this.selected.figure.dataset.productGallerySelected = false;
      this.selected.figure.tabIndex = -1;
      this.selected.figure = figure;
      this.selected.figure.dataset.productGallerySelected = true;
      this.selected.figure.tabIndex = 0;
      var viewInYourSpaceEls = this.el.querySelectorAll('[data-shopify-xr]'),
          setViewInYourSpaceID = function setViewInYourSpaceID(id) {
        for (var i = 0; i < viewInYourSpaceEls.length; i++) {
          viewInYourSpaceEls[i].dataset.shopifyModel3dId = id;            
        }
      };
      if (viewInYourSpaceEls.length) {
        setViewInYourSpaceID(viewInYourSpaceEls[0].dataset.defaultModelId);
      }
      this.pauseVideos();
      this.pauseModels();
      this.media.models.forEach(function (m) {
        if (m.figure === _this8.selected.figure) {
          if (!theme.detectmob) {
            m.ui.play();
          }
        }
      });
      switch (this.selected.figure.dataset.mediaType) {
        case 'external_video':
          let f = this.selected.figure;
          if (!f.getAttribute('loaded') && f.querySelector('template')) {
            f.querySelector('.youtube-container').appendChild(f.querySelector('template').content.firstElementChild.cloneNode(true));
            f.setAttribute('loaded', true);
          }
          f.focus();
          break;
        case 'video':          
          let v = this.selected.figure;
          if (v.classList.contains('visible-video')) {
            v.classList.remove('visible-video')
          } else {
            this._onVideoSelect(this.media.videos.filter(function (v) {
              return v.figure === _this8.selected.figure;
            })[0]);
          }          
          break;
        case 'model':
          setViewInYourSpaceID(this.selected.figure.dataset.media);
          break;
        case 'image':
          if (this.settings.zoom_enable && this.selected.figure.dataset.mediaType === 'image') {
            this._initZoom(this.selected.figure);
          };
          break;
        default:
          break;
      }
    }
  }, {
    key: "_selectMediaByIndex",
    value: function _selectMediaByIndex(index) {
      var _this = this,
          focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false,
          mSI = index;
      if (this.featured) {
        Glider(this.featured).scrollItem(parseInt(mSI));
        setTimeout(function() {
          _this.imageHeight(_this.featured.querySelector('[data-product-gallery-figure="' + mSI + '"] .media-container'));
        }, 250);
      }
      if (this.navigation) {
        Glider(this.navigation).scrollItem(parseInt(mSI));
        var thumbnail = this.thumbnails[index];
        if (this.selected.thumbnail) {
          this.selected.thumbnail.dataset.productGallerySelected = false;
        }
        this.selected.thumbnail = thumbnail;
        this.selected.thumbnail.dataset.productGallerySelected = true;
      }
      _this._onMediaSelect(index, focus);      
    }
  }, {
    key: "_initZoom",
    value: function _initZoom(figure) {
      var exists = this.media.images.filter(function (image) {
        return image.el.dataset.media === figure.dataset.media;
      });
      if (this.media.images.length === 0 || exists.length === 0) {
        this.media.images.push(new ProductZoom(figure));
      }
    }
  }]);
  return ProductGallery;
}();

theme.StoreAvailabilityLoad = function (container) {  
  var sectionId = container.getAttribute('data-section-id'),
      sectionType = container.getAttribute('data-section-type');
  var pJ = document.getElementById('ProductJson-' + sectionId),
      pS = 'product-select-' + sectionId;
  if (!pJ || !pJ.innerHTML.length) {
    return;
  }
  this.productSingleObject = JSON.parse(pJ.innerHTML);
  this.container = container;
  var sectionId = container.getAttribute('data-section-id');
  this.selectors = {
    storeAvailabilityContainer: '[data-store-availability-container]',
    originalSelectorId: '#product-select-' + sectionId,
    singleOptionSelector: 'form.product-form-' + sectionId + ' .single-option-selector'
  };
  this.storeAvailabilityContainer = container.querySelector(
    this.selectors.storeAvailabilityContainer
  );  
  if (this.storeAvailabilityContainer) {
    this.storeAvailability = new theme.StoreAvailability(
      this.storeAvailabilityContainer
    );
  }
  if (this.storeAvailability) {
    var e = document.getElementById(pS);
    var value = e.options[e.selectedIndex].value;
    this.storeAvailability.updateContent(
      value,
      this.productSingleObject.title
    );
  }
};
theme.StoreAvailability = (function(container) {
  var selectors = {
    storeAvailabilityModalProductTitle: '[data-store-availability-modal-product-title]'
  };
  function StoreAvailability(container) {
    this.container = container;
    this.sectionId = this.container.getAttribute('data-section-id');
    this.pT = this.container.dataset.productTitle;
  }
  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variantId) {
      let baseUrl = this.container.dataset.baseUrl;
      if (!baseUrl.endsWith('/')) {
        baseUrl = baseUrl + '/';
      }
      var variantSectionUrl =
          baseUrl +
          'variants/' +
          variantId +
          '/?section_id=store-availability';
      var self = this;
      fetch(variantSectionUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(storeAvailabilityHTML) {
        if (storeAvailabilityHTML.trim() === '') {
          return;
        }
        self.container.innerHTML = storeAvailabilityHTML;
        self.container.innerHTML = self.container.firstElementChild.innerHTML;
        var storeAvailabilityModalProductTitle = self.container.querySelector(
          selectors.storeAvailabilityModalProductTitle
        );
        if (storeAvailabilityModalProductTitle) {
          storeAvailabilityModalProductTitle.textContent = self.pT;
        }
        var el = self.container.querySelector('.srfc');        
        const body = document.body;
        const content = self.container.querySelector('.StoreAvailabilityModal');        
        if (!el) return;
        const m = document.querySelector('#avail-' + variantId);
        const mc = content.querySelector('.modal-container');
        const aB = document.getElementById('ajaxBusy');
        el.onclick = (e) => {          
          try {
            MicroModal.show('avail-' + variantId, {
              onShow: function(modal) {
                m.classList.add('loaded');
                mc.classList.add('loaded');
                aB.style.display = 'block';
                document.body.classList.add('modal-active');
              },
              onClose: function(modal) {
                setTimeout(function() {
                  m.classList.remove('loaded');
                  document.body.classList.remove('modal-active');
                }, 250);
                mc.classList.remove('loaded');
                aB.style.display = 'none';
              }
            });
          } catch (e) {
            console.log("micromodal error: ", e);
          }
          e.preventDefault();
        }
      });
    },
  });
  return StoreAvailability;
})();

function ProductDetails_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function ProductDetails_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function ProductDetails_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductDetails_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductDetails_defineProperties(Constructor, staticProps); return Constructor; }
var ProductDetails = function () {
  function ProductDetails(_ref, force) {
    var _this = this;
    var $el = _ref.$el,
        section = _ref.section;
    ProductDetails_classCallCheck(this, ProductDetails);
    this.el = $el;
    this.section = section;
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.postMessage = section.postMessage;
    this.type = section.type;
    this.$el = $el;
    this.$window = window;    
    this.$productInfo = $el.querySelector('#product-details-' + section.id);
    this.$atc = $el.querySelector('#add-to-cart-' + section.id);
    this.$variantDetails = this.$el.querySelector('#product-select-' + section.id);
    this._handleVariantChange = this._handleVariantChange.bind(this);
    if (this.el.querySelector('.product-images')) {
      this.productGallery = new ProductGallery(this.el.querySelector('.product-images'), {
        loop_enable: this.data.loop_enable,
        zoom_enable: this.data.zoom_enable,
        section: section
      });
    }
    this.listeningForVariantChange = false;
    this.listenForVariantChange();
    if (!this.onboarding) {
      this.form = new ProductForm(this.$productInfo, {        
        form: this.$el.querySelector('#add-item-form-' + section.id),
        productEl: this.$el,
        product: this.data.product_info,
        productVariants: this.data.product_variants,
        type: this.type,
        moneyFormat: theme.moneyFormat,
        postMessage: section.postMessage,
        useHistory: this.data.use_history
      });
      let event = new CustomEvent('product-variant-switch', {
        detail: {
          variant: this.form.variantHelper.getSelectedVariant()
        }
      });
    }
    Quantity(this.$el);    
    if ($el.querySelector('.product-single__store-availability-container')) {
      theme.StoreAvailabilityLoad($el);
    }
    var el = this.$el.querySelectorAll('.tooltip'),
        m = document.querySelector('#quick-modal'),
        mc = m.querySelector('.modal-container'),
        mcC = mc.querySelector('.modal-content'), 
        aB = document.getElementById('ajaxBusy');
    el.forEach(function(e) {
      e.onclick = function(ev){      
        const content = this.getAttribute('data-container'),
              content_container = this.parentNode;
        e.focus();
        aB.style.display = 'block';
        const section = JSON.parse(content_container.querySelector('.' + content).innerText);
        MicroModal.show('quick-modal', {
          onShow: function(modal) {
            m.classList.add('loaded');
            mc.classList.add('loaded');
            document.body.classList.add('modal-active');
          },
          onClose: function(modal) {              
            setTimeout(function() {
              m.classList.remove('loaded');
              document.body.classList.remove('modal-active');            
              mcC.innerHTML = '';            
            }, 250);
            mc.classList.remove('loaded');
            aB.style.display = 'none';
          }
        });    
        m.classList.add('loaded');
        mcC.innerHTML = section;
      };
    });
    var pg = $el.querySelector('.product-gift-' + section.id);
    if (pg) {
      var i = pg.querySelector('input[type="checkbox"]'),
          d = pg.querySelector('details');
      i.onchange = function(ev){
        d.toggleAttribute('open')
      }
    }
  }
  ProductDetails_createClass(ProductDetails, [{
    key: "listenForVariantChange",
    value: function listenForVariantChange() {
      if (!this.listeningForVariantChange) {
        window.addEventListener('product-variant-switch', this._handleVariantChange);
        this.listeningForVariantChange = true;
      }
    }
  }, {
    key: "stopListeningForVariantChange",
    value: function stopListeningForVariantChange() {
      if (this.listeningForVariantChange) {
        window.removeEventListener('product-variant-switch', this._handleVariantChange);
        this.listeningForVariantChange = false;
      }
    }
  },{
    key: "unload",
    value: function unload() {
      this.stopListeningForVariantChange();
    }
  }, {
    key: "_handleVariantChange",
    value: function _handleVariantChange(event) {
      var data = event.detail;
      this._onVariantChange(data);
    }
  }, {
    key: "_onVariantChange",
    value: function _onVariantChange(_ref2, force) {
      var _this = this;
      var variant = _ref2.variant,
          firstLoad = _ref2.firstLoad,
          isProduct = _ref2.isProduct;
      if (isProduct && !isProduct(this.data.product_info)) {
        return;
      }
      if (this.productGallery) {
        this.productGallery.selectMediaByVariant(variant);
      }      
      if (this.$el.querySelector('[data-atc]')) {
        this.$el.querySelector('[data-atc]').disabled = !variant.available;
        this.$el.querySelector('[data-atc]').textContent = variant.available ? this.data.text.product_available : this.data.text.product_unavailable;
      }
      if (this.$el.querySelector('[data-quantity]')) {
        var vD = _this.$variantDetails,
            dQI = this.$el.querySelector('[data-quantity] input'),
            pSk = this.$el.querySelector('.stock.error'),
            max = parseInt(vD.options[vD.selectedIndex].getAttribute('data-max')),
            min = parseInt(vD.options[vD.selectedIndex].getAttribute('data-min'));
        dQI.setAttribute('min', min);
        pSk.style.display = 'none';
        if (vD.options[vD.selectedIndex].disabled) {
          dQI.value = '0';
          dQI.setAttribute('max', '0');
        } else {
          if (min == 0) {
            dQI.value = 0;
          } else {
            dQI.value = 1;
          }          
          if (max) {
            dQI.setAttribute('max', max);
          } else {
            dQI.removeAttribute('max');
          }
        }        
      }      
      if (this.$el.querySelector('.product-details-price')) {
        var $price = this.$productInfo.querySelector('[data-variant-price]'),
            $compareAtPrice = this.$productInfo.querySelector('[data-variant-compare-at-price]'),
            $savings = this.$productInfo.querySelector('[data-savings]'),
            $savingsTotal = this.$productInfo.querySelector('[data-savings-total]'),
            $unitPrice = this.$productInfo.querySelector('[data-unit-price]');
        if (variant.price > 0) {
          $price.innerHTML = Shopify.formatMoney(variant.price, theme.moneyFormat);
        } else {
          $price.innerHTML = this.data.text.product_free;          
        }
        if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
          $compareAtPrice.classList.remove('hidden');
          $savings.classList.remove('hidden');
          $compareAtPrice.innerHTML = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat);
          $savingsTotal.innerHTML = Shopify.formatMoney(variant.compare_at_price - variant.price,theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        } else {
          $compareAtPrice.classList.add('hidden');
          $savings.classList.add('hidden');
        }
        if (variant.unit_price) {
          $unitPrice.classList.remove('hidden');
          var $unitPriceAmount = $unitPrice.querySelector('[data-unit-price-amount]'),
              $unitPriceMeasure = $unitPrice.querySelector('[data-unit-price-measure]');      
          if ($unitPriceAmount) {
            $unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, theme.moneyFormat);
          }
          if ($unitPriceMeasure) {
            if (variant.unit_price_measurement.reference_value !== 1) {
              $unitPriceMeasure.innerHTML = "".concat(variant.unit_price_measurement.reference_value);
            } else {
              $unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
            }
          }                      
        } else {
          $unitPrice.classList.add('hidden');
        }        
      }
      if (this.$el.querySelector('.product-logistics')) {
        this.$logistics = this.$productInfo.querySelector('.product-logistics');
        this.$vendor = this.$productInfo.querySelector('[data-variant-vendor]');        
        this.$sku = this.$productInfo.querySelector('[data-variant-sku]');
        this.$skuSeperator = this.$productInfo.querySelector('[data-variant-sku-seperator]');        
        this.$barcode = this.$productInfo.querySelector('[data-variant-barcode]');
        this.$barcodeSeperator = this.$productInfo.querySelector('[data-variant-barcode-seperator]');
        theme.sku = false;
        theme.barcode = false;
        if (this.$sku || this.$barcode) {
          if (this.$sku) {
            if (variant.sku) {
              theme.sku = true;
              this.$logistics.classList.remove('hidden');
              this.$sku.parentNode.classList.remove('hidden');
              this.$sku.textContent = variant.sku;
              if (this.$vendor) {
                this.$skuSeperator.classList.remove('hidden');
              }
            } else {
              theme.sku = false;
              this.$sku.parentNode.classList.add('hidden');
              this.$skuSeperator.classList.add('hidden');
            }
          }
          if (this.$barcode) {
            if (variant.barcode) {
              theme.barcode = true;
              this.$logistics.classList.remove('hidden');
              this.$barcode.parentNode.classList.remove('hidden');
              this.$barcode.textContent = variant.barcode;
              if (this.$vendor || variant.sku && this.$sku) {
                this.$barcodeSeperator.classList.remove('hidden');
              }
            } else {
              theme.barcode = false;
              this.$barcode.parentNode.classList.add('hidden'); 
              this.$barcodeSeperator.classList.add('hidden');           
            }
          }          
          if (!this.$vendor && !theme.sku && !theme.barcode) {
            this.$logistics.classList.add('hidden');
          }
        }
      }
      if ($el.querySelector('.product-single__store-availability-container')) {
        theme.StoreAvailabilityLoad($el);
      }
      if (document.getElementById('inventory-' + this.section.id)) {
        var pI = pI = document.getElementById('inventory-' + this.section.id),
            pIC = parseInt(pI.getAttribute('data-inv')),
            pID = document.getElementById('product-select-' + this.section.id),
            pIA = parseInt(pID.options[pID.selectedIndex].getAttribute('data-inv')),
            pII = pID.options[pID.selectedIndex].getAttribute('data-inc'),
            pIID = pID.options[pID.selectedIndex].getAttribute('data-inc_date'),
            free = theme.language.products_product_free;
        if (variant.inventory_management) {
          if (pIA > 0 && pIA < pIC) {
            if (pI) {
              if(pII == 'true') {
                pI.innerHTML = '<h4><span>' + theme.language.products_general_inv_msg_1 + '&nbsp;' + pIA + '&nbsp;' + theme.language.products_general_inv_msg_2 + '</span><span class="error-text"><small><span class="icon icon-bell"></span> ' + pIID + '</small</span></h4>';
              } else {
                pI.innerHTML = '<h4><span>' + theme.language.products_general_inv_msg_1 + '&nbsp;' + pIA + '&nbsp;' + theme.language.products_general_inv_msg_2 + '</span></h4>';
              }
            }
          } else if (pIA > pIC) {
            if (pI) {
              pI.innerHTML = '<h4><span>' + theme.language.products_product_available + '</span></h4>';
            }
          } else if (pIA < 1) {
            if (variant.available) {
              if (pI) {
                pI.innerHTML = '<h4><span>' + theme.language.products_product_available + '</span></h4>';
              }
            } else {
              if (pI) {
                if(pII == 'true') {
                  pI.innerHTML = '<h4><span>' + theme.language.products_product_sold_out + '</span><span class="error-text"><small><span class="icon icon-bell"></span> ' + pIID + '</small></span></h4>';
                } else {
                  pI.innerHTML = '<h4><span>' + theme.language.products_product_sold_out + '</span></h4>'
                }
              }
            }
          } else {
            if (pI) {
              pI.innerHTML = '<h4><span>' + theme.language.products_product_available + '</span></h4>';
            }
          }
        } else {
          if (pI) {
            pI.innerHTML = '<h4><span>' + theme.language.products_product_available + '</span></h4>';
          }
        }
      }
      var vMF = this.$el.querySelectorAll('.variant_metafields');
      if (vMF.length > 0) {  
        fetch(this.data.product_url + '?variant=' + variant.id + '&section_id=' + this.section.id)
        .then(function(r) {
          return r.text();
        }).then(function(j) {
          const htmlDocument = new DOMParser().parseFromString(j, 'text/html');
          vMF.forEach(function(v) {            
            var nV = v.getAttribute('id'),
                section = htmlDocument.querySelector('#' + nV);            
            if (!section) {
              return;
            }
            v.innerHTML = section.innerHTML;
          });        
        }).catch(function(err) {
          console.error('!: ' + err)
        });
      };
    }
  }]);
  return ProductDetails;
}();

function Product_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function Product_createClass(Constructor, protoProps, staticProps) { if (protoProps) Product_defineProperties(Constructor.prototype, protoProps); if (staticProps) Product_defineProperties(Constructor, staticProps); return Constructor; }
var Product = function () {
  function Product(section) {
  var pID = document.getElementById('product-select-' + section.id),
      pJ = JSON.parse(document.getElementById('ProductJson-' + section.id).innerHTML);
  this.$el = section.el;
  this.section = section;
  this.section.data = pJ;    
  if (this.section.data.product_info === null) {
    return;
  } 
  this.productDetails = new ProductDetails({
    $el: this.$el,
    section: section
  });
  function RecV() {
    const pA = [];
    let jR,
        jRA,
        jRAS;
    const nP = 16;
    const pD = {
      pID: pJ.product_info.id
    } 
    pA.push(pD);
    const cpT = pD.pID; 
    const pDS = JSON.stringify(pA);
    const lD = localStorage.getItem('rVP');
    if(lD == null) { 
      localStorage.setItem('rVP', pDS);
    } else if (lD != null ) {
      const opD = localStorage.getItem('rVP');
      const cpD = (opD.match(/pID/g) || []).length;
      const rP =  opD.includes(cpT);
      if (cpD < nP && rP == false) {
        jR = JSON.parse(opD);
        jRA = jR.concat(pA);
        jRAS = JSON.stringify(jRA);
        localStorage.setItem('rVP', jRAS);
      }
      else if (cpD >= nP && rP == false) {
        jR = JSON.parse(opD);
        jR.shift();
        jRA = jR.concat(pA);
        jRA =  JSON.stringify(jRA);
        localStorage.setItem('rVP', jRA);
      }
    }
  }
  RecV();  
  }
  Product_createClass(Product, [{
    key: "onSectionMessage",
    value: function onSectionMessage(name, data) {
      if (this.productDetails.productGallery) {
        this.productDetails.productGallery.onSectionMessage(name, data);
      }
    }
  }, {
    key: "onSectionUnload",
    value: function onSectionUnload() {
      if (this.productDetails) this.productDetails.unload();
    }
  }]);
  return Product;
}();

document.addEventListener('Section:Loaded', function(event){
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  let sectionId = sectionContainer.dataset.sectionId;
  if(sectionType === 'product-alt'){
    const s = {
      el: sectionContainer, 
      id: sectionId, 
      type: sectionType
    };
    Product(s);
  }
})

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  let sectionId = sectionContainer.dataset.sectionId;
  if(sectionType === 'product_page' || sectionType === 'product-alt' && !sectionContainer.classList.contains('ignore')){
    const s = {
      el: sectionContainer, 
      id: sectionId, 
      type: sectionType
    };
    Product(s);
    sectionContainer.classList.add('ignore');
  }
})

theme.Product = (function() {
  function Product(section) {
    var sectionId = section.getAttribute('data-section-id'),
        type = section.getAttribute('data-carousel-type');
    if (type == 'section') {
      Tabs(section);
      if (Shopify.designMode) {        
        var Carousel = document.getElementById('tabs-carousel-' + sectionId);
        Product.prototype.onBlockSelect = function(ev) {
          var tI = section.querySelectorAll('.tabs-id-' + sectionId + ' a'),
              tB = section.querySelectorAll('.tab-body-id-' + sectionId),
              tT = ev.target,
              tH = section.querySelector(ev.target.getAttribute('href'));
          if (tI) {
            tI.forEach(function(t) {
              t.classList.remove('first');
              t.setAttribute('tabindex','-1');
              t.removeAttribute('aria-selected');
            });
            tB.forEach(function(t) {
              t.classList.add('hide');
              var s = t.querySelector('.product-loop[data-glider="loaded"]');
              if (s) {
                s.setAttribute('data-glider', 'ignore');
              }
            });
          }
          tT.classList.add('first');
          tT.removeAttribute('tabindex');
          tT.setAttribute('aria-selected','true');      
          tH.classList.remove('hide');
          var loop = tH.querySelector('.product-loop[data-glider="unloaded"]');
          if (loop) {
            loop.setAttribute('data-glider', 'loaded');
            if (loop.getAttribute('data-glider') === 'loaded') {
              Sliders(section);
            }
          }
          var tC = document.getElementById('tabs-carousel-' + sectionId);
          if (tC) {        
            var mSI = parseInt(ev.target.getAttribute('data-gslide'));
            Glider(tC).scrollItem(parseInt(mSI));
          }
        };
      }
    } 
  }
  return Product;
})();